import React, { useState } from 'react';
import axiosInstance from '../request';
import { URL } from '../api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const EmployeeForm = ({ initialData = {} }) => {
  const [employee, setEmployee] = useState({
    name: '',
    email: '',
    phoneNumber: '',
    designation: '',
    address: '',
    gender: '',
    joiningDate: '',
    status: true,
    user_name: '',
    password: '',
    groupId: '',
    admin: false,
    ...initialData,
    user_name: '', 
    password: '', 
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEmployee((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      user_name: employee.user_name,
      name: employee.name,
      phoneNumber: employee.phoneNumber,
      email: employee.email,
      gender: parseInt(employee.gender), // 1, 2, or 3
      groupId: parseInt(employee.groupId || 0),
      isActive: employee.status ? 1 : 0,
      admin: employee.admin ? 1 : 0,
      dept: employee.designation,
      password: employee.password,
      address: employee.address,
      joiningDate: employee.joiningDate + 'T10:30:00',
    };

   try {
  await axiosInstance.post(URL.CREATE_EMPLOYEE, payload);
  alert('Employee created successfully');

  // Reset form
  setEmployee({
    name: '',
    email: '',
    phoneNumber: '',
    designation: '',
    address: '',
    gender: '',
    joiningDate: '',
    status: true,
    user_name: '',
    password: '',
    groupId: '',
    admin: false,
  });
} catch (err) {
  console.error('Create failed:', err);
  alert('Failed to create employee');
} 
  }

  return (
    <form onSubmit={handleSubmit} className="card shadow-sm">
      <div className="card-header bg-dark text-white">
        {initialData.id ? 'Edit Employee' : 'Add New Employee'}
      </div>
      <div className="card-body row g-3">

        <div className="col-md-6">
          <label><strong>Name</strong></label>
          <input type="text" name="name" value={employee.name} onChange={handleChange} className="form-control" required />
        </div>

        <div className="col-md-6">
          <label><strong>Email</strong></label>
          <input type="email" name="email" value={employee.email} onChange={handleChange} className="form-control" required />
        </div>

        <div className="col-md-6">
          <label><strong>Phone</strong></label>
          <input type="text" name="phoneNumber" value={employee.phoneNumber} onChange={handleChange} className="form-control" required />
        </div>

        <div className="col-md-6">
          <label><strong>Designation</strong></label>
          <input type="text" name="designation" value={employee.designation} onChange={handleChange} className="form-control" required />
        </div>

        <div className="col-md-12">
          <label><strong>Address</strong></label>
          <textarea name="address" value={employee.address} onChange={handleChange} className="form-control" rows="2" />
        </div>

        <div className="col-md-6">
          <label><strong>Gender</strong></label>
          <select name="gender" value={employee.gender} onChange={handleChange} className="form-select" required>
            <option value="">Select</option>
            <option value="1">Male</option>
            <option value="2">Female</option>
            <option value="3">Other</option>
          </select>
        </div>

        <div className="col-md-6">
          <label><strong>Joining Date</strong></label>
          <input
            type="date"
            name="joiningDate"
            value={employee.joiningDate}
            onChange={handleChange}
            className="form-control"
            required
          />
        </div>

        <div className="col-md-6">
          <label><strong>Username</strong></label>
          <input
            type="text"
            name="user_name"
            value={employee.user_name}
            onChange={handleChange}
            className="form-control"
            required
            autoComplete="off"
          />
        </div>

        <div className="col-md-6">
          <label><strong>Password</strong></label>
          <input
            type="password"
            name="password"
            value={employee.password}
            onChange={handleChange}
            className="form-control"
            required
            autoComplete="new-password"
          />
        </div>

        <div className="col-md-6">
  <label><strong>Group ID</strong></label>
  <input
    type="number"
    name="groupId"
    value={employee.groupId}
    onChange={handleChange}
    className="form-control"
    required
  />
</div>

          <div className="col-md-3 d-flex align-items-end">
            <div className="form-check me-3">
              <input
                className="form-check-input"
                type="checkbox"
                name="status"
                checked={employee.status}
                onChange={handleChange}
                id="isActive"
              />
              <label className="form-check-label" htmlFor="isActive">
                <strong>Is Active</strong>
              </label>
            </div>

            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                name="admin"
                checked={employee.admin}
                onChange={handleChange}
                id="isAdmin"
              />
              <label className="form-check-label" htmlFor="isAdmin">
                <strong>Is Admin</strong>
              </label>
            </div>
          </div>
        <div className="col-12 mt-3">
          <button type="submit" className="btn btn-success w-100">
            {initialData.id ? 'Update Employee' : 'Add Employee'}
          </button>
        </div>
      </div>
    </form>
  );
};

export default EmployeeForm;
